module.exports = __webpack_public_path__ + "static/media/arrow.73e935cd.png";